import React from 'react';

import { IImageProcessor } from 'app/interfaces/IImageProcessor';

const IImageProcessorContext = React.createContext<IImageProcessor>(undefined);

export default IImageProcessorContext;
